import { v4 } from "uuid";

export type GesecInvoice = {
  "@odata.context": string;
  "@odata.etag": string;
  /** ID is the key to identify the invoice */
  id: string;
  systemId: string;
  processNumber: string;
  debitorNumber: string;
  processStatus: string;
  invoiceNo: string;
  postSalesInvoiceNo: string;
  rows: GesecInvoiceRow[];
};

export function addRow(invoice: GesecInvoice): GesecInvoice {
  const newRow: GesecInvoiceRow = newGesecInvoiceRow(invoice);

  return setOrderFieldToIndex({
    ...invoice,
    rows: [...invoice.rows, newRow],
  });
}

/**
 * newGesecInvoiceRow is a helper to create a new row. This row is
 * not yet added to the invoice. This is helpful when dealing with
 * tables and row actions.
 */
export function newGesecInvoiceRow(invoice: GesecInvoice): GesecInvoiceRow {
  return {
    "@odata.etag": "",
    invoiceId: invoice.id,
    systemId: "",
    id: v4(),
    kind: "Text",
    order: invoice.rows.length,
    positionNo: "",
    resourceNo: "",
    description: "",
    description2: "",
    unit: "",
    quantity: 0,
    unitPrice: 0,
    lineAmount: 0,
  };
}

export function updateRows(
  invoice: GesecInvoice,
  rows: GesecInvoiceRow[],
): GesecInvoice {
  return setOrderFieldToIndex({
    ...invoice,
    rows,
  });
}

export function duplicateRow(row: GesecInvoiceRow): GesecInvoiceRow {
  return { ...row, id: v4() };
}

function setOrderFieldToIndex(invoice: GesecInvoice): GesecInvoice {
  return {
    ...invoice,
    rows: invoice.rows.map((row, index) => ({
      ...row,
      order: index,
    })),
  };
}

export type GesecInvoiceRowKind =
  | "Resource"
  | "Subresource"
  | "ResourceComment"
  | "Text";

export const GesecInvoiceRowKindList: GesecInvoiceRowKind[] = [
  "Resource",
  "Subresource",
  "ResourceComment",
  "Text",
];

export const GesecInvoiceRowKindListSelectItems = GesecInvoiceRowKindList.map(
  (k) => ({ value: k, label: k }),
);

export interface GesecInvoiceRow {
  "@odata.etag": string;
  invoiceId: string;
  systemId: string;
  id: string;
  kind: GesecInvoiceRowKind;
  order: number;
  positionNo: string;
  resourceNo: string;
  description: string;
  description2: string;
  unit: string;
  quantity: number;
  unitPrice: number;
  lineAmount: number;
}
